import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import summaryTypographyOrStyles from './summaryTypographyOrStyles';
import Translation from '../../../../../common/components/translation/Translation';

interface ISummaryTypographyOrProps {
  priceTextClass?: string;
}

const SummaryTypographyOr: FC<ISummaryTypographyOrProps> = ({ priceTextClass }) => {
  const { secondaryPrice, priceText, marginNormal } = summaryTypographyOrStyles();

  return (
    <Typography className={clsx([secondaryPrice, priceText, marginNormal, priceTextClass])} data-test="text:price:or">
      <Translation id="spc.configuratorSummary.or" />
    </Typography>
  );
};

export default SummaryTypographyOr;
